import { useState } from "react";
import {
  clearReaderSessionStorage,
  readStoredReaderContentSnapshot,
  readStoredReaderTarget,
  writeReaderContentSnapshot,
  writeReaderSessionTarget,
  type ReaderContentSnapshot,
  type ReaderSessionTarget,
} from "./reader-session";

export function useReaderSessionWorkspace() {
  const [recentReading, setRecentReading] = useState<ReaderSessionTarget | null>(null);

  function initializeRecentReading() {
    setRecentReading(readStoredReaderTarget(window.sessionStorage, window.localStorage));
  }

  function readReaderSession() {
    return readStoredReaderTarget(window.sessionStorage, window.localStorage);
  }

  function writeReaderSession(target: ReaderSessionTarget) {
    writeReaderSessionTarget(target, window.sessionStorage, window.localStorage);
    setRecentReading(target);
  }

  function readContentSnapshot() {
    return readStoredReaderContentSnapshot(window.sessionStorage, window.localStorage);
  }

  function writeContentSnapshot(snapshot: ReaderContentSnapshot) {
    writeReaderContentSnapshot(snapshot, window.sessionStorage, window.localStorage);
  }

  function clearReaderSession() {
    clearReaderSessionStorage(window.sessionStorage, window.localStorage);
    setRecentReading(null);
  }

  return {
    recentReading,
    initializeRecentReading,
    readReaderSession,
    writeReaderSession,
    readContentSnapshot,
    writeContentSnapshot,
    clearReaderSession,
  };
}
